<div class="inside-container" *ngIf="userDetails && code">
    <div fxLayout="row">
        <div fxFlex="70" fxLayoutAlign="start center">
            <h3 class="tab-header" i18n="@@1172087673707212662" t="1172087673707212662">E-Invoicing Channels</h3>
        </div>
    </div>

    <div fxLayout="column" fxLayoutGap="5px">
        <p *ngIf="userDetails.isSupplier && (isPrimary || isEDI || isFinance)">
            <span i18n="@@5540525507346049764" t="5540525507346049764">The E-Invoicing channel selection is available to users to view or select their organization's
                preference of invoicing channels. Selected E-Invoicing channels will go to Tesla for review and
                approval for validation purposes.</span>
            <br>
            <br>
            <tsl-alert status="info">
                <span i18n="@@EinvoicingChannelRequestBanner1" t="EinvoicingChannelRequestBanner1" bypassTranslate="true" #banner1
                        [tParams]="banner1HtmlTags">ALL Tesla suppliers were
                    automatically set-up for <span class="red-color"><strong>Portal</strong></span>
                    invoice submission using the "Create Invoice from PO" (Indirect and Capex) or "Create Invoice from Shipment"
                    (Direct) portal pages. Please review the training guides located in
                    <a target="_blank" [href]="guidelineUrl">Documents & Guidelines</a> (search filters: Procure To Pay » Invoicing).</span>
                <br>
                <span i18n="@@EinvoicingChannelRequestBanner2" t="EinvoicingChannelRequestBanner2" bypassTranslate="true" #banner2
                        [tParams]="banner2HtmlTags"><strong><u>ONLY</u></strong>
                    the <span class="red-color"><strong>Primary Contact</strong></span>
                    and <span class="red-color"><strong>Finance Lead</strong></span> can submit a request to enable one of our more advanced
                    E-Invoicing Channels (<strong>CXML</strong>, <strong>EDI</strong>, <strong>Self-Billing</strong>
                    or <strong>PortalCSV</strong> - <u>depending on availability and eligibility</u>).
                    These advanced E-Invoicing Channels <strong>require testing</strong> and <strong>validation</strong>,
                    which can take anywhere between 7 days to several months to complete. During testing,
                    you will need to submit your invoices using the <span class="red-color"><strong>Portal</strong></span>
                    invoicing channel referenced above.</span>
            </tsl-alert>
        </p>
        <p *ngIf="userDetails.isSupplier && !isPrimary && !isEDI && !isFinance">
            <span i18n="@@7365557338463444464" t="7365557338463444464">You are not authorized to view this content.</span>
        </p>
        <p *ngIf="userDetails.isTeslaUser">
            <span i18n="@@2245838887671612201" t="2245838887671612201">The Supplier E-Invoicing channel selection is available to manage the organization different E-Invoicing channels.
            Please go to</span>&nbsp;<a target="_blank" [href]="wsmUrl">warp supplier master</a>&nbsp;<span i18n="@@508d2cd7fc189b4a4577ad4d55b0f32dfb1a4797" t="508d2cd7fc189b4a4577ad4d55b0f32dfb1a4797"> to make any changes.</span>
        </p>
    </div>

    <div class="internal-container" *ngIf="userDetails.isTeslaUser || (userDetails.isSupplier && (isPrimary || isEDI || isFinance))">
        <div *ngIf="channelRequestEnabled">
            <div class="col right top-buttons" *ngIf="userDetails.isSupplier && (isPrimary || isFinanceLead)">
                <button tsl-button  [disabled]="preventativeHold==true" size="medium" color="blue" tslToolTip="Subscribe to e-invoicing channels" (click)="onButtonClick()" i18n="@@ENABLEEINVOICINGCHANNELS" t="ENABLEEINVOICINGCHANNELS">
                    ENABLE E-INVOICING CHANNELS
                </button>
            </div>
            <tesla-sidebar title="Enable e-Invoicing Channels for Entities" width="50vw" position="right" #createChannelRequestSideBar
            [confirm-close]="createChannelRequestForm.changed" (onClose)="createChannelRequestForm.clear()"
            [confirm-message]="confirmMessage"
            [confirm-title]='confirmTitle'>
                <app-channel-onboarding #createChannelRequestForm (onComplete)="onCreateRequestComplete()"></app-channel-onboarding>
            </tesla-sidebar>
        </div>
        <app-einvoicing-channels-grid></app-einvoicing-channels-grid>
    </div>

</div>
